import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneArrowUpRightIcon, EnvelopeIcon } from '@heroicons/react/16/solid';

const Footer = () => {
  return (
    <footer className="bg-[#111827] text-white pt-6 mobile-normal:pt-8 tablet-small:pt-10 pb-6 mobile-normal:pb-7 tablet-small:pb-8" style={{ fontFamily: "Monstserrat, proxima-nova, Helveti, sans-serif" }}>
      <div className="container mx-auto px-3 mobile-normal:px-4 mobile-large:px-5 tablet-small:px-6 laptop-standard:px-8 laptop-large:px-12">
        <div className="grid grid-cols-1 tablet-standard:grid-cols-2 laptop-small:grid-cols-5 gap-4 mobile-normal:gap-5 mb-4 mobile-normal:mb-5">
          {/* Company Info */}
          <div className="lg:col-span-2 space-y-4">
            <div className="flex items-center justify-start space-x-3">
              <div className="relative top-2">
                <svg
                  width="200"
                  height="90"
                  viewBox="0 0 600 150"
                  fill="none"
                  stroke="#2a3890"
                  preserveAspectRatio="none"
                  className="block drop-shadow w-[120px] h-[54px] mobile-normal:w-[140px] mobile-normal:h-[63px] mobile-large:w-[160px] mobile-large:h-[72px] tablet-small:w-[180px] tablet-small:h-[81px] tablet-standard:w-[200px] tablet-standard:h-[90px]"
                  aria-hidden="true"
                >
                  <path
                    strokeWidth="12"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                    d="M 40 130 L 580 130 L 580 60 L 400 10 L 350 20 V 10 H 320 V 35  L 310 40 L 250 50"
                  />
                </svg>
                <img
                  src='/images/TM_Logo.png'
                  alt="Turner Construction"
                  className="absolute left-0 laptop-small:left-1/2 laptop-small:-translate-x-1/2 bottom-4 h-6 mobile-normal:h-7 mobile-large:h-8 tablet-small:h-9 tablet-standard:h-10 w-auto drop-shadow-lg"
                  onClick={() => window.location.href = '/'}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
            <div className="text-xs mobile-normal:text-sm text-white space-y-1">
              <p className="leading-relaxed">2231 Crystal Drive, Arlington VA 22202, USA</p>
              {/* <p className="leading-relaxed">8 The Green Ste B Dover, DE 19901-3618</p> */}
              <p className="leading-relaxed"><PhoneArrowUpRightIcon className="w-4 h-4 inline-block mr-1" />+1 (202) 445 4459{" "}
                <EnvelopeIcon className="w-4 h-4 inline-block mr-1" />
                <a href="https://mail.google.com/mail/?view=cm&to=info@tmgroupdc.com" target="_blank" rel="noopener noreferrer">
                  info@tmgroupdc.com
                </a>
              </p>
            </div>
          </div>

          {/* Our Company */}
          <div className='text-left mt-6 mobile-normal:mt-8 tablet-small:mt-10'>
            <h4 className="font-semibold text-white mb-3 mobile-normal:mb-4 text-xs mobile-normal:text-sm uppercase tracking-wide">
              Our Company
            </h4>
            <ul className="space-y-2 mobile-normal:space-y-3 text-xs mobile-normal:text-sm">
              <li>
                <Link
                  to="/about-us"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={() => window.location.href = '/about-us'}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/leadership"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('leadership');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                      window.location.href = '/leadership';
                    }
                  }}
                >
                  Our Leadership
                </Link>
              </li>
              <li>
                <Link
                  to="/about#locations"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('locations');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                      window.location.href = '/locations';
                    }
                  }}
                >
                  Locations
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className='text-left mt-6 mobile-normal:mt-8 tablet-small:mt-10'>
            <h4 className="font-semibold text-white mb-3 mobile-normal:mb-4 text-xs mobile-normal:text-sm uppercase tracking-wide">
              Resources
            </h4>
            <ul className="space-y-2 mobile-normal:space-y-3 text-xs mobile-normal:text-sm">
              <li>
                <Link
                  to="/news-insights"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={() => window.location.href = '/news-insights'}
                >
                  News & Insights
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={() => window.location.href = '/contact'}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={() => window.location.href = '/privacy-policy'}
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div className='text-left mt-6 mobile-normal:mt-8 tablet-small:mt-10'>
            <h4 className="font-semibold text-white mb-3 mobile-normal:mb-4 text-xs mobile-normal:text-sm uppercase tracking-wide">
              Business Hours
            </h4>
            <ul className="space-y-2 mobile-normal:space-y-3 text-xs mobile-normal:text-sm">
              <li>
                <Link
                  to="/contact"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={() => window.location.href = '/contact'}
                >
                  Monday - Friday: 8:00 AM - 6:00 PM EST
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={() => window.location.href = '/contact'}
                >
                  Saturday: 9:00 AM - 4:00 PM EST
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white hover:text-gray-300 transition-colors duration-200"
                  onClick={() => window.location.href = '/contact'}
                >
                  Sunday: By Appointment Only
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-6 mobile-normal:pt-7 tablet-small:pt-8">
          <div className="flex flex-col tablet-standard:flex-row justify-between items-start tablet-standard:items-center gap-3 mobile-normal:gap-4">
            <div className="text-xs mobile-normal:text-sm tablet-standard:text-base laptop-standard:text-base text-left text-white">
              <p>Copyright ©{new Date().getFullYear()}
                <a href='/' className='font-light hover:text-gray-300'>{" "}TM-Group International Building Excellence Since 2008</a>
              </p>
            </div>
            {/* Social Icons */}
            <div className="flex items-center space-x-4">
              <a
                href="https://www.facebook.com/tminternationalconstruction/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-colors duration-200"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/tminternationalgroup/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-colors duration-200"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/tm-international-group/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-300 transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

